import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { JustificationTypes } from 'contracts/JustificationTypes';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'FETCH_JUSTIFICATION_TYPES_',
  }
);

export interface FetchJustificationTypesState {
  data: JustificationTypes[];
  loading: boolean;
  errorMessage: string | null;
}

export interface FetchJustificationTypesRequestAction {
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: JustificationTypes[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: FetchJustificationTypesState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: FetchJustificationTypesState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: FetchJustificationTypesState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: FetchJustificationTypesState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: FetchJustificationTypesState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const fetchJustificationTypes = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const FetchJustificationTypesTypes = Types;
export const FetchJustificationTypesActions = Creators;
